module.exports = __webpack_public_path__ + "static/media/footer-tendances.b5f0c075.png";